import ApiEndpoints from '@/config/ApiEndpoints';
import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';

export default class UpdateSubscriptionQuantity {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * UpdateSubscriptionQuantity constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle updating the given subscription's quantity.
     *
     * @param {number} subscriptionId
     * @param {number} quantity
     *
     * @return {Promise}
     */
    handle(subscriptionId, quantity) {
        let apiUrl = prepareUrl(ApiEndpoints['subscriptions.quantity.update'], [subscriptionId]);

        return this.apiService
            .patch(apiUrl, {
                amount: quantity,
            });
    }
}
